<div class="current__package-container">
    <span>{{'migrateHalo.currentPackage' | translate}}</span>
    <div class="package">
        <div class="pacakge__name">{{name()}}</div>
        <div class="package__price">{{price() ?? '0' | currency}}</div>
    </div>
</div>